// Libs
import Vue from 'vue';
import Router from 'vue-router';
import Notifications from 'vue-notification';
import VModal from 'vue-js-modal';
import VueEvents from 'vue-events';
import VueSignaturePad from 'vue-signature-pad';
// Middleware
import authMiddleware from '@/middleware/authMiddleware';

// Components
import App from '@/App.vue';
import Login from '@/views/Login';
import NotFound from '@/views/NotFound';

import store from '@/store';

Vue.use(VueEvents);
Vue.use(Router);
Vue.use(Notifications);
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });
Vue.use(VueSignaturePad);

const router = new Router({
	mode: 'history',
	base: '/',
	routes: [
		{
			path: '/',
			name: 'home',
			component: () => {
				if(store.getters['auth/loggedIn'] !== true) {
					router.push({name: 'login'}).catch((error) => { if (error) console.error(error) });
				}
				if (store.getters['auth/allowedTo']([
					'dashboard/uitvoerdersploeg'
				])) {
					router.push({ name: 'dashboard_uitvoerdersPloeg' }).catch((error) => { if (error) console.error(error) });
				} else if (store.getters['auth/allowedTo']([
					'map',
					'map/planning',
					'map/appointments',
					'map/uitvoering'
				])) {
					router.push({ name: 'map' }).catch((error) => { if (error) console.error(error) });
				} else if (store.getters['auth/allowedTo']([
					'admin',
					'admin/users',
					'admin/sync',
					'admin/geo',
					'admin/colors'
				])) {
					router.push({ name: 'admin' }).catch((error) => { if (error) console.error(error) });
				} else if (store.getters['auth/allowedTo']('qualityappointments')) {
					const isMobile = window.matchMedia('only screen and (max-width: 900px)').matches && 'ontouchstart' in document.documentElement;
					if (isMobile === false && store.getters['auth/allowedTo']('map/quality')) {
						router.push({ name: 'map' }).catch((error) => { if (error) console.error(error) });
						return;
					}
					router.push({ name: 'qualityAppointments' }).catch((error) => { if (error) console.error(error) });
				} else if (store.getters['auth/allowedTo']('mobileapp')) {
					const isMobile = window.matchMedia('only screen and (max-width: 900px)').matches && 'ontouchstart' in document.documentElement;
					if (isMobile === false && store.getters['auth/allowedTo']('map/marketing')) {
						router.push({ name: 'map' }).catch((error) => { if (error) console.error(error) });
						return;
					}
					router.push({ name: 'mobileapp' }).catch((error) => { if (error) console.error(error) });
				} else if (store.getters['auth/allowedTo']( ['projectappointments/view','projectappointments/edit'])) {
					router.push({ name: 'projectAppointments' }).catch((error) => { if (error) console.error(error) });
				} else {
					return import(/* webpackChunkName: "pagenotfound" */'@/views/NotFound');
				}
			},
		},
		{
			path: '/login',
			name: 'login',
			component: Login
		},
		{
			path: '/dashboard',
			name: 'dashboard',
			component: () => import(/* webpackChunkName: "dashboard" */'@/views/dashboard/Layout'),
			children: [
				{
					path: '',
					redirect: () => {
						if (store.getters['auth/allowedTo']([
							'dashboard/uitvoerdersploeg'
						])) {
							return {name: 'dashboard_uitvoerdersPloeg'};
						}
					}
				},
				{
					path: 'uitvoerders-ploeg',
					name: 'dashboard_uitvoerdersPloeg',
					component: () => import(/* webpackChunkName: "dashboard_uitvoerdersPloeg" */'@/views/dashboard/UitvoerderPloeg'),
					meta: {
						privilege: 'dashboard/uitvoerdersploeg'
					}
				},
				{
					path: 'absent',
					name: 'dashboard_absent',
					component: () => import(/* webpackChunkName: "dashboard_absent" */'@/views/dashboard/Absent'),
					meta: {
						privilege: 'dashboard/0-afwezig'
					}
				},
				{
					path: 'leave',
					name: 'dashboard_leave',
					component: () => import(/* webpackChunkName: "dashboard_leave" */'@/views/dashboard/Leave'),
					meta: {
						privilege: 'dashboard/1-verlof'
					}
				},
				{
					path: 'working-hours',
					name: 'dashboard_workingHours',
					component: () => import(/* webpackChunkName: "dashboard_workingHours" */'@/views/dashboard/WorkingHours'),
					meta: {
						privilege: 'dashboard/2-uren'
					}
				}
			]
		},
		{
			path: '/map',
			name: 'map',
			component: () => import(/* webpackChunkName: "map" */'@/views/Map'),
			meta: {
				privilege: [
					'map',
					'map/planning',
					'map/marketing',
					'map/appointments',
					'map/uitvoering',
					'map/quality'
				],
			}
		},
		{
			path: '/bestanden/:id',
			name: 'bestanden',
			component: () => import(/* webpackChunkName: "bestanden" */'@/views/CompanyFiles'),
			meta: {
				privilege: [
					'files/view/sales/offerte',
					'files/view/sales/voorkant',
					'files/view/sales/achterkant',
					'files/view/sales/subsidie',
					'files/view/sales/fotos',
					"files/view/uitvoering/startwaarde",
					"files/view/uitvoering/spouwmuurisolatie/voor",
					"files/view/uitvoering/spouwmuurisolatie/handtekening-vooropname",
					"files/view/uitvoering/spouwmuurisolatie/tijdens",
					"files/view/uitvoering/spouwmuurisolatie/handtekening-uitvoering",
					"files/view/uitvoering/spouwmuurisolatie/eindsituatie",
					"files/view/uitvoering/spouwmuurisolatie/eindwaarde",
					"files/view/uitvoering/spouwmuurisolatie/handtekening-eindsituatie",
					"files/view/uitvoering/spouwmuurisolatie/handtekening-akkoord",
					"files/view/uitvoering/vloerisolatie/startmateriaal",
					"files/view/uitvoering/vloerisolatie/voor",
					"files/view/uitvoering/vloerisolatie/handtekening-uitvoering",
					"files/view/uitvoering/vloerisolatie/tijdens",
					"files/view/uitvoering/vloerisolatie/handtekening-eindsituatie",
					"files/view/uitvoering/vloerisolatie/eindsituatie",
					"files/view/uitvoering/vloerisolatie/eindmateriaal",
					"files/view/uitvoering/vloerisolatie/handtekening-akkoord"
				],
			}
		},
		{
			path: '/afspraken',
			name: 'mobileapp',
			component: () => import(/* webpackChunkName: "mobile_app" */'@/views/MobileApp'),
			meta: {
				privilege: 'mobileapp',
			}
		},
		{
			path: '/afspraken/:id',
			name: 'appointmentdetail',
			component: () => import(/* webpackChunkName: "appointment_detail" */'@/views/AppointmentDetail'),
			meta: {
				privilege: 'mobileapp',
			}
		},
		{
			path: '/kwaliteit-afspraken',
			name: 'qualityAppointments',
			component: () => import(/* webpackChunkName: "mobile_app" */'@/views/qualityAppointment/List'),
			meta: {
				privilege: ['qualityappointments/view','qualityappointments/edit']
			}
		},
		{
			path: '/kwaliteit-afspraken/:id',
			name: 'qualityAppointmentdetail',
			component: () => import(/* webpackChunkName: "appointment_detail" */'@/views/qualityAppointment/Detail'),
			meta: {
				privilege: ['qualityappointments/view','qualityappointments/edit']
			}
		},
		{
			path: '/uitvoering-afspraken',
			name: 'projectAppointments',
			component: () => import(/* webpackChunkName: "mobile_app" */'@/views/projectAppointment/List'),
			meta: {
				privilege: ['projectappointments/view','projectappointments/edit']
			}
		},
		{
			path: '/uitvoering-afspraken/:id',
			name: 'projectAppointmentsdetail',
			component: () => import(/* webpackChunkName: "mobile_app" */'@/views/projectAppointment/Detail'),
			meta: {
				privilege:  ['projectappointments/view','projectappointments/edit'],
			}
		},
		{
			path: '/doorgeven',
			name: 'doorgeven',
			component: () => import(/* webpackChunkName: "mobile_app" */'@/views/SubmitAvailability'),
			meta: {
				privilege:  ['doorgeven/ziekte','doorgeven/verlof', 'doorgeven/uren'],
			}
		},
		{
			path: '/doorgeven/uren',
			name: 'doorgevenUren',
			component: () => import(/* webpackChunkName: "mobile_app" */'@/views/MobileWorkingHours.vue'),
			meta: {
				privilege:  ['doorgeven/uren'],
			}
		},
		{
			path: '/support-fotos/:token',
			name: 'supportPhotos',
			component: () => import(/* webpackChunkName: "mobile_app" */'@/views/SupportPhotos'),
			meta: {
				// privilege:  ['projectappointments/view','projectappointments/edit'],
			}
		},
		{
			path: '/admin',
			component: () => import(/* webpackChunkName: "admin_layout" */'@/views/admin/Layout'),
			children: [
				{
					path: '',
					name: 'admin',
					component: () => import(/* webpackChunkName: "admin_dashboard" */'@/views/admin/Dashboard'),
					meta: {
						privilege: [
							'admin',
							'admin/users',
							'admin/sync',
							'admin/geo',
							'admin/colors'
						],
					}
				},
				{
					path: 'users',
					name: 'admin_users',
					component: () => import(/* webpackChunkName: "admin_users" */'@/views/admin/Users'),
					meta: {
						privilege: 'admin/users',
					}
				},
				{
					path: 'sync',
					name: 'admin_sync',
					component: () => import(/* webpackChunkName: "admin_sync" */'@/views/admin/Sync'),
					meta: {
						privilege: 'admin/sync',
					}
				},
				{
					path: 'geo',
					name: 'admin_geo',
					component: () => import(/* webpackChunkName: "admin_geolocations" */'@/views/admin/GeoLocations'),
					meta: {
						privilege: 'admin/geo',
					}
				},{
					path: 'colors',
					name: 'colors',
					component: () => import(/* webpackChunkName: "admin_geolocations" */'@/views/admin/Colors'),
					meta: {
						privilege: 'admin/colors',
					}
				},
			]
		},
		{
			path: '*',
			redirect: '/login'
		}
	]
});

function initialize() {
	const appInst = new Vue({
		store,
		router,

		mounted() {
			window.addEventListener('click', (e) => {
				if (store.state.activeDropdown) {
					if (e.target.closest('.Slider')) {
						return;
					}
					if (e.target.dataset == null || e.target.dataset.uid != store.state.activeDropdown._uid) {
						store.state.activeDropdown.closeDropdown();
					}
				}
			});
		},

		data: {},
		render: h => h(App)
	});

	router.beforeResolve((to, from, next) => {
		if (to.meta.privilege) {
			return authMiddleware({
				next: next,
				to: to,
				from: from,
				router: router,
				store: store,
				app: appInst,
				privilege: to.meta.privilege,
			});
		}

		return next();
	})

	appInst.$mount('#app');
}

store.dispatch('loadConfig').then(() => {
	store.dispatch('auth/fetchViewer').then(() => {
		store.commit('setReady');
		initialize();
	});
}).catch(() => {
	store.commit('setReady');
	initialize();
});
